<template>
  <div>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Módosítás'"
      placement="top"
      v-can="'settings.location.update'"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        @click="updateLocation"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
      v-can="'settings.location.delete'"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteLocation"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>
<script>
  export default {
    props: ['location'],
    data() {
      return {
        deleteButtonLoader: false,
        deleteConfirmVisible: false
      };
    },
    methods: {
      async deleteLocation() {
        this.deleteButtonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('location/delete', this.location.id);
          this.$store.dispatch('location/fetchAll');
        } catch (e) {
        }
        this.deleteButtonLoader = false;
      },
      async updateLocation() {
        this.$router.push('/lists/locations/update/' + this.location.id);
      }
    }
  };
</script>
